import React from 'react';
import { ChevronDownIcon } from '@heroicons/react/24/outline';

interface SortOption {
  value: string;
  label: string;
  order: 'ASC' | 'DESC';
}

interface SortFilterProps {
  currentSort: string;
  currentOrder: 'ASC' | 'DESC';
  onSortChange: (sort: string, order: 'ASC' | 'DESC') => void;
}

const sortOptions: SortOption[] = [
  { value: 'created_at', label: '최신순', order: 'DESC' },
  { value: 'created_at', label: '오래된순', order: 'ASC' },
  { value: 'usage_count', label: '인기순', order: 'DESC' },
  { value: 'title', label: '제목순', order: 'ASC' },
];

const SortFilter: React.FC<SortFilterProps> = ({
  currentSort,
  currentOrder,
  onSortChange,
}) => {
  const [isOpen, setIsOpen] = React.useState(false);
  
  const currentOption = sortOptions.find(
    option => option.value === currentSort && option.order === currentOrder
  ) || sortOptions[0];

  const handleOptionClick = (option: SortOption) => {
    onSortChange(option.value, option.order);
    setIsOpen(false);
  };

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="inline-flex items-center px-3 py-2 border border-gray-300 rounded-md bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
      >
        정렬: {currentOption.label}
        <ChevronDownIcon className="ml-2 h-4 w-4" />
      </button>

      {isOpen && (
        <>
          <div
            className="fixed inset-0 z-10"
            onClick={() => setIsOpen(false)}
          />
          <div className="absolute right-0 z-20 mt-1 w-48 bg-white rounded-md shadow-lg border border-gray-200">
            <div className="py-1">
              {sortOptions.map((option, index) => (
                <button
                  key={index}
                  onClick={() => handleOptionClick(option)}
                  className={`
                    w-full text-left px-4 py-2 text-sm transition-colors
                    ${
                      option.value === currentSort && option.order === currentOrder
                        ? 'bg-primary-50 text-primary-700'
                        : 'text-gray-700 hover:bg-gray-50'
                    }
                  `}
                >
                  {option.label}
                </button>
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default SortFilter;